// @core/api/endpoints/document/update_clause.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentClauseResponse,
  UpdateClauseRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update clause
 * Partially updates a clause. Only DRAFT/REVIEW clauses can be edited freely; APPROVED clauses typically need to be superseded by a new version.
 */
export async function UpdateClause(
  clause_id: string,
  data: UpdateClauseRequest,
  options?: RequestOptions
): Promise<DocumentClauseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/clauses/:clause_id`;
  requestPath = requestPath.replace(':clause_id', encodeURIComponent(clause_id));
  const requestOptions = options;
  return client.patch<DocumentClauseResponse>(requestPath, data, requestOptions);
}
